import { useState } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { Image } from '~/components/Image'
import { PasswordAuthenticationSchema } from '~/validation-schemas'
import { Client } from '../../customClients/client'
import { useSession } from '../../hooks'
import { Button } from '../Button'
import { Form } from '../Form'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './AuthenticationDrawer.module.scss'
import { AuthenticationDrawersTypes } from './AuthenticationDrawer.types'
import PasswordDetailsForm from './PasswordDetailsForm'

const ResetPasswordAuthenticationDrawer = () => {
  const { session } = useSession()
  const [passwordResetSuccessfull, setPasswordResetSuccessfull] =
    useState(false)
  const router = useRouter()

  const handleResetPassword = async (data: {
    newPassword: string
    confirmPassword: string
  }) => {
    try {
      const tokenVal = router.query.token as string
      await Client.auth.resetPassword(
        { newPassword: data.newPassword, tokenVal },
        session
      )
      setPasswordResetSuccessfull(true)
    } catch (err) {}
  }

  const renderContent = (register, errors, newPassword) => {
    return passwordResetSuccessfull ? (
      <div className=' flex-1 w-full flex flex-col items-center gap-4 pt-16 md:pt-32 px-4'>
        <Image
          src='/images/DialogueJaycar.svg'
          alt='lock'
          width={350}
          height={350}
          className={classNames('hidden', styles.jaycarContent)}
        />
        <Image
          src='/images/DialogueRTM.svg'
          alt='lock'
          width={350}
          height={350}
          className={classNames('hidden', styles.rtmContent)}
        />
        <Typography
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyXLargeBold}
          className={styles.title}>
          Reset Password
        </Typography>
        <div className='mb-6 text-center'>
          <Typography
            tag={TypographyTag.div}
            variant={TypographyVariant.BodyRegularExtraLineHeight}>
            Your password has successfully been changed.
          </Typography>
          <Typography
            tag={TypographyTag.div}
            variant={TypographyVariant.BodyRegularExtraLineHeight}>
            Please log in to your Jaycar account with your new password.
          </Typography>
        </div>
      </div>
    ) : (
      <div className='flex-1 pt-16 px-4 overflow-y-auto'>
        <Typography variant={TypographyVariant.Heading5} tag={TypographyTag.p}>
          Password reset
        </Typography>
        <div className='mt-6 pt-8'>
          <PasswordDetailsForm
            register={register}
            errors={errors}
            newPassword={newPassword}
          />
        </div>
      </div>
    )
  }

  const renderFooter = (isButtonDisabled: boolean) => {
    return (
      <div
        className={classNames(
          styles.footerBottom,
          'flex items-center gap-x-4 w-full border-t'
        )}>
        {passwordResetSuccessfull ? (
          <Button
            status='primary'
            fluid
            size='lg'
            theme={{ root: styles.footerButton }}
            onClick={() => {
              router.replace(
                `#${AuthenticationDrawersTypes.Login}`,
                undefined,
                {
                  shallow: true,
                }
              )
            }}>
            Sign in
          </Button>
        ) : (
          <Button
            htmlType='submit'
            status='primary'
            disabled={isButtonDisabled}
            fluid
            size='lg'
            theme={{ root: styles.footerButton }}>
            Reset Password
          </Button>
        )}
      </div>
    )
  }
  return (
    <Form
      className={styles.formWrapper}
      validationSchema={PasswordAuthenticationSchema}
      useFormProps={{ mode: 'onChange' }}
      onSubmit={handleResetPassword}>
      {({ register, formState: { errors, isValid }, getValues }) => {
        const { newPassword } = getValues()
        return (
          <>
            {renderContent(register, errors, newPassword)}
            {renderFooter(!isValid)}
          </>
        )
      }}
    </Form>
  )
}

export default ResetPasswordAuthenticationDrawer
